import { render, staticRenderFns } from "./ItemFilters.vue?vue&type=template&id=d8962faa&"
import script from "./ItemFilters.vue?vue&type=script&lang=js&"
export * from "./ItemFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports